import { Injectable } from '@angular/core';
import { HandlerService } from '../../handlers/handlers.service';
import { MethodsService } from 'src/app/core/http/method.service';
import { environment as params } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SegurosWPService extends MethodsService {
  constructor(_HandlerService: HandlerService, http: HttpClient) {
    super(_HandlerService, http);
    this.setApi((<any>params).api.wp);
  }
  getAllData() {
    return this.get('apimj/seguros/components/home');
  }
  getDataDestacado() {
    return this.get('apimj/seguros/components/home?identifier=ensuredestacado');
  }
  getDataBanner() {
    return this.get('apimj/seguros/components/home?identifier=banners');
  }
  getDataProductos() {
    return this.get('apimj/seguros/components/home?identifier=productos');
  }
  getDataTestimonios() {
    return this.get('apimj/seguros/components/home?identifier=testimonios');
  }
  getDataPreguntas() {
    return this.get('apimj/seguros/components/home?identifier=preguntas');
  }
  getDataModal() {
    return this.get('apimj/seguros/components/home?identifier=ensuremodal');
  }
  getDataRepos() {
    return this.get('apimj/seguros/components/home?identifier=ensurepos');
  }
  getDataRecomendaciones() {
    return this.get('apimj/seguros/components/home?identifier=ensurerecomendaciones');
  }
  getDataSingle(slug) {
    return this.get('apimj/seguros/components/single?kte=' + slug);
  }
}
